// extracted by mini-css-extract-plugin
export default {"snackbarContainer":"Snackbar_snackbarContainer__U-VQd","snackbarContent":"Snackbar_snackbarContent__pVJ7H","closeButton":"Snackbar_closeButton__Z1VEH"};